import React from 'react';

import { Species } from '../../../../../../../api/fishrules/getSpeciesAtLocation';
import { Button } from '../../../../../../../components/Clickables/Buttons/Button';
import { BackButton } from '../../../../../../../components/Clickables/Controls/BackButton/BackButton';
import { Heading } from '../../../../../../../components/Heading/Heading';
import { ArrowRightIcon } from '../../../../../../../components/Icons/ArrowRightIcon';
import { LatLng } from '../../../../../../../components/LatLng/LatLng';
import { Modal } from '../../../../../../../components/Modal/Modal';
import { ModalBody } from '../../../../../../../components/Modal/ModalBody';
import { Text } from '../../../../../../../components/Text/Text';
import { IBoundary } from '../../../../../../../helpers/hooks/fishrules/useRegulationBoundaryAtLocation';
import { ICoordinates } from '../../../../../../../interfaces/geo';
import { useExplore } from '../../../../../context/ExploreContext';

interface IProps {
  species: Species | undefined;
  coordinates: ICoordinates | undefined;
  boundaries: IBoundary[] | undefined;
}

export const SingleSpeciesHeader = ({ species, coordinates, boundaries }: IProps) => {
  const { saveParamsInUrl } = useExplore();
  return (
    <>
      <BackButton
        onClick={() => {
          saveParamsInUrl({ drawerView: 'regulations', drawerViewId: undefined });
        }}
        className="mb-4"
        variant="controlLakeFogBg"
      />
      {species && (
        <Heading as="h1" variant="sm" className="mt-0 mb-2">
          {species.species}
        </Heading>
      )}
      <div className="mb-1.5">
        {boundaries && boundaries.length > 0 && (
          <Modal
            trigger={props => (
              <Button {...props} data-testid="area-arrow-icon" variant="textPrimary">
                {species?.location_name || boundaries[0].name}
                <span className="ml-1.5">
                  <ArrowRightIcon height={20} width={20} />
                </span>
              </Button>
            )}
          >
            <ModalBody>
              <Heading variant="sm" className="mb-4">
                Regulation zones
              </Heading>
              <LatLng
                className="mb-8"
                latitude={coordinates!.latitude}
                longitude={coordinates!.longitude}
              />
              <Text className="text-abyss" variant="md">
                Regulation zones based on the selected location:
              </Text>
              <ul>
                {boundaries.map(boundary => (
                  <li
                    className="body-text-sm text-abyss font-semibold"
                    key={`boundary-${boundary.id}`}
                  >
                    {boundary.name}
                  </li>
                ))}
              </ul>
            </ModalBody>
          </Modal>
        )}
      </div>
      <LatLng
        className="mb-8"
        latitude={coordinates!.latitude}
        longitude={coordinates!.longitude}
      />
    </>
  );
};
